module.exports = __webpack_public_path__ + "static/media/microscope-03.26d39c5e.PNG";